import script from "./TrendChannelView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendChannelView.vue?vue&type=script&setup=true&lang=js"

import "./TrendChannelView.vue?vue&type=style&index=0&id=78d560e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d560e4"]])

export default __exports__